
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'

export default {
mounted() {

this.loadLatest();
this.$store.commit('UPDATE_PAGE_TITLE',  this.titles)
},
computed: {




},
data(){
return {
daiwannum:0,
shenghenum:0,
yiwannum:0,
chaoqinum:0,
tuihuinum:0,
num:2,
itemList:'',
titles:'',
infoShow: false,
tanchukuang:'',
totalData:[],
urls:[],
filelist:[],
filelist1:[],
filelist2:[],
filelist3:[],
filelist4:[],
filelist5:[],
filelist6:[],
imgfile:[],
imgfile1:[],
imgfile2:[],
imgfile3:[],
imgfile4:[],
imgfile5:[],
imgfile6:[],
fileList2: [
{ url: 'https://img.yzcdn.cn/vant/leaf.jpg' },


{ url: 'https://cloud-image', isImage: true }
],
imgszs:[],

test:{
"height": '',
"overflow": "scroll"

}

}
},
mounted(){
this.doPage(localStorage.getItem("wxid"))
this.doPage1(localStorage.getItem("wxid"))
this.doPage2(localStorage.getItem("wxid"))
this.doPage3(localStorage.getItem("wxid"))
this.doPage4(localStorage.getItem("wxid"))

},
methods:{
afterRead(files, detail) {
files.forEach(element => {
element.rate = 10; 
setTimeout(() => {
element.status = null;
}, 2000);
});
},

dianzan(item){
console.log("点赞")
if(_.isEmpty(item)){
console.log("点赞111")
}else{
console.log("点赞222")
return item.includes('点赞')
}
},
zhuangfa(item){
console.log("转发")
if(_.isEmpty(item)){

}else{

return item.includes('转发')
}
},
zaikan(item){
console.log("在看")
if(_.isEmpty(item)){

}else{

return item.includes('在看')
}
},
pinglun(item){
console.log("评论")
if(_.isEmpty(item)){

}else{

return item.includes('评论')
}
},
jubao(item){
console.log("举报")
if(_.isEmpty(item)){

}else{

return item.includes('举报')
}
},
guanzhu(item){
console.log("关注")
if(_.isEmpty(item)){

}else{

return item.includes('关注')
}
},
toupiao(item){
console.log("投票")
if(_.isEmpty(item)){

}else{

return item.includes('投票')
}
},

tiao(title,id,demand,bumen,urls){
console.log(title)
this.$router.push({ name: 'Ttask', params: { titles:title,id:id,demand:demand,bumen:bumen,urls:urls}});
},
open(item){
console.log("进入跳转")
var externalUrl =  this.tanchukuang.url;
console.log(item)

window.location.href = item
},
listDes(item){
console.log(item)
this.tanchukuang = item

var strArr = item.url

console.log(112233)
console.log(strArr)
console.log(strArr.split(','))
console.log(112233)
strArr.substring(0,strArr.length-1)


this.urls =  strArr.substring(0,strArr.length-1).split(',')

if(item.demand.includes('点赞')){
this.imgfile =  item.example_liked_img.split(',')
this.imgfile.forEach((item,index)=>{
let newarr = this.$httpUrl +item
this.$set(this.filelist, index, {url:newarr});
})
}
if(item.demand.includes('在看')){
this.imgfile1 =  item.example_watching_img.split(',')
this.imgfile1.forEach((item,index)=>{
let newarr1 = this.$httpUrl +item
this.$set(this.filelist1, index, {url:newarr1});
})
}
if(item.demand.includes('转发')){
this.imgfile2 =  item.example_transmit_img.split(',')
this.imgfile2.forEach((item,index)=>{
let newarr2 = this.$httpUrl +item
this.$set(this.filelist2, index, {url:newarr2});
})
}
if(item.demand.includes('评论')){
this.imgfile3 =  item.example_comment_img.split(',')
this.imgfile3.forEach((item,index)=>{
let newarr3 = this.$httpUrl +item
this.$set(this.filelist3, index, {url:newarr3});
})
}
if(item.demand.includes('举报')){
this.imgfile4 =  item.example_report_img.split(',')
this.imgfile4.forEach((item,index)=>{
let newarr3 = this.$httpUrl +item
this.$set(this.filelist4, index, {url:newarr3});
})
}
if(item.demand.includes('关注')){
this.imgfile5 =  item.example_gz_img.split(',')
this.imgfile5.forEach((item,index)=>{
let newarr3 = this.$httpUrl +item
this.$set(this.filelist5, index, {url:newarr3});
})
}
if(item.demand.includes('投票')){
this.imgfile6 =  item.example_tp_img.split(',')
this.imgfile6.forEach((item,index)=>{
let newarr3 = this.$httpUrl +item
this.$set(this.filelist6, index, {url:newarr3});
})
}

this.test.height = (document.body.clientHeight-260)+'px'
console.log(this.test, '------')
this.infoShow = true
},
task(titles){

console.log(titles)
this.titles = titles

sessionStorage.setItem("pageTitle",this.titles)
this.$router.push({ name: 'Dtask', query: { titles:this.titles}});
},
loadLatest(){
let self=this;
this.baseAjax({
url:'../../../static/basicData/latestActivity.json',
showLoading:true,
success:function(data){
console.log(data)
self.itemList=data.returnObject
}
})
},

doPage(wxid) {

this.$axios.get(this.$httpUrl + '/daren/personwork/list?ryid='+wxid+'&status='+ '未提交未审核'+'&authority=普通员工' ,).then(res => res.data).then(res => {
console.log(res)
this.totalData = res.rows
this.daiwannum = res.total

})
},
doPage1(wxid) {
this.$axios.get(this.$httpUrl + '/daren/personwork/list?ryid='+wxid+'&status='+ '已提交未审核'+'&authority=普通员工' ,).then(res => res.data).then(res => {
console.log(res)

this.shenghenum = res.total


})
},
doPage2(wxid) {
this.$axios.get(this.$httpUrl + '/daren/personwork/list?ryid='+wxid+'&status='+ '已提交已通过'+'&authority=普通员工' ,).then(res => res.data).then(res => {
console.log(res)

this.yiwannum = res.total


})
},
doPage3(wxid) {
this.$axios.get(this.$httpUrl + '/daren/personwork/list?ryid='+wxid+'&status='+ '超期'+'&authority=普通员工' ,).then(res => res.data).then(res => {
console.log(res)

this.chaoqinum = res.total


})
},
doPage4(wxid) {
this.$axios.get(this.$httpUrl + '/daren/personwork/list?ryid='+wxid+'&status='+ '已提交未通过'+'&authority=普通员工' ,).then(res => res.data).then(res => {
console.log(res)

this.tuihuinum = res.total


})
},
getimg(img){
console.log("img")
console.log(img)
console.log("img")
var imgs = img.split(',')

return this.$httpUrl2+imgs[0]
},
getimg2(img){
console.log(img)
return this.$httpUrl2+img
},



},
components: {
Tabbar,
TabbarItem,
XHeader,
XButton,
XImg
}
}




// WEBPACK FOOTER //
// ./src/components/member/activities/activityIndex.vue